import HeroSection from '@/components/landing/HeroSection';
import FeaturesSection from '@/components/landing/FeaturesSection';
import StatsSection from '@/components/landing/StatsSection';
import HowItWorksSection from '@/components/landing/HowItWorksSection';
// import TestimonialsSection from '@/components/landing/TestimonialsSection';
import CTASection from '@/components/landing/CTASection';
import { Footer } from '@/components/layout/Footer';
import CoursesPreviewSection from '@/components/landing/CoursesPreviewSection';
import { Helmet } from 'react-helmet-async';
import FeaturesShowcaseSection from '@/components/landing/FeaturesShowcaseSection';

export function LandingPage() {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <main>
                <Helmet>
                    <title>Sekuu | Training platform</title>
                    <meta
                        name="description"
                        content="Create training courses automatically with AI."
                    />
                </Helmet>
                <HeroSection />
                <FeaturesSection />
                <FeaturesShowcaseSection />
                <StatsSection />
                <HowItWorksSection />
                <CoursesPreviewSection />
                {/* <TestimonialsSection /> */}
                <CTASection />
            </main>
            <Footer />
        </div>
    );
}
